module.exports = __webpack_public_path__ + "img/3_122.6bb05931.png";